<template>
  <div class="flex flex-wrap space-y-6 pt-6 lg:flex-nowrap lg:space-x-6 lg:space-y-0">
    <div class="w-full max-w-[475px] rounded-xl bg-gray-100 bg-opacity-50 px-6 pb-14 pt-6">
      <h4 class="text-xl text-gray-600">
        {{ info.title }}
      </h4>
      <h5 class="mt-10 text-gray-600">
        {{ info.contact.title }}
      </h5>
      <div class="mt-2 grid grid-cols-2 gap-2 font-normal text-gray-300 lg:grid-cols-3">
        <span>
          {{ info.contact.name }}
        </span>
        <span class="font-medium lg:col-span-2">{{ values.name }}</span>
        <span>
          {{ info.contact.lastName }}
        </span>
        <span class="font-medium lg:col-span-2">{{ values.lastName }}</span>
        <span>
          {{ info.contact.email }}
        </span>
        <span class="font-medium lg:col-span-2">{{ values.email }}</span>
      </div>
      <h5 class="mt-10 text-gray-600">
        {{ info.attachments.title }}
      </h5>
      <div class="mt-2 grid grid-cols-2 gap-2 font-normal text-gray-300 lg:grid-cols-3">
        <span v-if="isCampaignPosition">LinkedIn:</span>
        <span v-else>
          {{ info.attachments.cv }}
        </span>
        <span
          v-if="isCampaignPosition"
          class="font-medium lg:col-span-2"
          >{{ values.linkedin }}</span
        >
        <span
          v-else
          class="font-medium lg:col-span-2"
          >{{ values.cv[0].name }}</span
        >
        <span v-if="values.cover">
          {{ info.attachments.cover }}
        </span>
        <span
          v-if="values.cover"
          class="font-medium lg:col-span-2"
          >{{ values.cover[0].name }}</span
        >
        <span v-if="values.links">
          {{ info.attachments.links }}
        </span>
        <span
          v-if="values.links"
          class="font-medium lg:col-span-2"
          >{{ values.links }}</span
        >
      </div>
    </div>
    <div class="rounded-xl bg-gray-100 bg-opacity-50 p-4 lg:p-6">
      <h4 class="mb-6 text-xl text-gray-600">Recommendation letter</h4>

      <label
        for="message"
        class="max-w-md text-xs uppercase text-gray-300">
        How do you know the candidate and why are you recommending them for the role?
      </label>
      <textarea
        id="message"
        :placeholder="additional.message.placeholder"
        :value="values.message"
        class="mt-2 h-24 w-full resize-none rounded-xl border-2 border-gray-200 bg-white px-4 py-3 text-gray-500 placeholder-gray-250 lg:mr-28"
        @change="(e: Event) => setSelected((e.target as HTMLTextAreaElement).value, 'message')" />
    </div>
  </div>
</template>

<script setup lang="ts">
  type step2Props = {
    title: string
    values: {
      name: string
      lastName: string
      email: string
      linkedin: string
      cv: FileList
      cover: FileList | null
      links: string
      message: string
    }
    info: {
      title: string
      contact: {
        title: string
        name: string
        lastName: string
        email: string
      }
      attachments: {
        title: string
        cv: string
        cover: string
        links: string
      }
    }
    additional: {
      title: string
      description: string
      message: {
        label: string
        placeholder: string
      }
    }
    cta: string
    isCampaignPosition: boolean
  }

  defineProps<step2Props>()
  const emit = defineEmits(['inputChange'])

  function setSelected(value: string, name: 'message') {
    emit('inputChange', value, name)
  }
</script>
